export const isAuthenticated = ({ user }) => user.isAuthenticated;
export const user = ({ user }) => user.info;
